import { featureItems } from "@/mocks/comicGuide";

export default function FeatureGrid() {
  return (
    <section id="features" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
            <i className="ri-apps-2-line"></i> 功能总览
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">六大核心功能，看漫体验全面升级</h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            无论你是刚接触漫画阅读软件的新手，还是想深挖功能的老手，下面这些核心能力都值得掌握。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {featureItems.map((f, idx) => (
            <article
              key={f.title}
              className="group relative rounded-2xl border border-background-200 bg-background-50 p-6 transition hover:-translate-y-1 hover:border-primary-200 hover:bg-background-100"
            >
              <span className="absolute right-5 top-5 font-heading text-2xl text-background-300 transition group-hover:text-primary-200">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}